/** Domain service module: exports.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'

class PDFService {
  downloadCashBook(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/pdf/cashBook`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  downloadMedicalRecord(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/pdf/medicalRecord`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  downloadPersonMedicalRecord(id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/pdf/medicalRecord/${id}`, 'get', undefined, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  downloadPersonEventAuthorization(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/pdf/personAuthorization`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  downloadEventAuthorizations(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/pdf/eventAuthorizations`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  downloadInvoices(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/pdf/invoices`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  downloadReceipt(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/pdf/receipt/${data}`, 'post', {}, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  downloadAnalytical(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/pdf/analytical`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }
}

class ExcelService {
  exportCashBook(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/excel/cashBook`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  exportInvoices(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/excel/invoices`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  exportSubGroups(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/excel/subGroups`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  exportSubGroupMembers(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/excel/subGroupMembers`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }

  exportAnalytical(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/excel/analytical`, 'post', data, undefined, undefined, 'blob');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }
}

export const pdf = new PDFService()
export const excel = new ExcelService()
